// Male 2
import AppleMale1SFX from './audio/Voices/Male1/Apple.mp3';
import BananaMale1SFX from './audio/Voices/Male1/Banana.mp3';
import GrapeMale1SFX from './audio/Voices/Male1/Grape.mp3';
import OrangeMale1SFX from './audio/Voices/Male1/Orange.mp3';
import WatermelonMale1SFX from './audio/Voices/Male1/Watermelon.mp3';
import PluralAppleMale1SFX from './audio/Voices/Male1/Apples.mp3';
import PluralBananaMale1SFX from './audio/Voices/Male1/Bananas.mp3';
import PluralGrapeMale1SFX from './audio/Voices/Male1/Grapes.mp3';
import PluralOrangeMale1SFX from './audio/Voices/Male1/Oranges.mp3';
import PluralWatermelonMale1SFX from './audio/Voices/Male1/Watermelons.mp3';
import RequestOrderMale1Sfx from './audio/Voices/Male1/GdayCanIGet.mp3';
import CorrectOrderMale1Sfx from './audio/Voices/Male1/ThanksMate.mp3';
import WrongOrderMale1Sfx from './audio/Voices/Male1/ThisAintMyOrder.mp3';
import OneMale1SFX from './audio/Voices/Male1/One.mp3';
import TwoMale1SFX from './audio/Voices/Male1/Two.mp3';
import ThreeMale1SFX from './audio/Voices/Male1/Three.mp3';
import FourMale1SFX from './audio/Voices/Male1/Four.mp3';
import AndMale1SfX from './audio/Voices/Male1/And.mp3';
import FiveMale1SfX from './audio/Voices/Male1/Five.mp3';

// Male 2
import AppleMale2SFX from './audio/Voices/Male2/Apple.mp3';
import BananaMale2SFX from './audio/Voices/Male2/Banana.mp3';
import GrapeMale2SFX from './audio/Voices/Male2/Grape.mp3';
import OrangeMale2SFX from './audio/Voices/Male2/Orange.mp3';
import WatermelonMale2SFX from './audio/Voices/Male2/Watermelon.mp3';
import PluralAppleMale2SFX from './audio/Voices/Male2/Apples.mp3';
import PluralBananaMale2SFX from './audio/Voices/Male2/Bananas.mp3';
import PluralGrapeMale2SFX from './audio/Voices/Male2/Grapes.mp3';
import PluralOrangeMale2SFX from './audio/Voices/Male2/Oranges.mp3';
import PluralWatermelonMale2SFX from './audio/Voices/Male2/Watermelons.mp3';
import RequestOrderMale2Sfx from './audio/Voices/Male2/GdayCanIGet.mp3';
import CorrectOrderMale2Sfx from './audio/Voices/Male2/ThanksMate.mp3';
import WrongOrderMale2Sfx from './audio/Voices/Male2/ThisAintMyOrder.mp3';
import OneMale2SFX from './audio/Voices/Male2/One.mp3';
import TwoMale2SFX from './audio/Voices/Male2/Two.mp3';
import ThreeMale2SFX from './audio/Voices/Male2/Three.mp3';
import FourMale2SFX from './audio/Voices/Male2/Four.mp3';
import AndMale2SfX from './audio/Voices/Male2/And.mp3';
import FiveMale2SfX from './audio/Voices/Male2/Five.mp3';

// Female 1
import AppleFemale1SFX from './audio/Voices/Female1/Apple.mp3';
import BananaFemale1SFX from './audio/Voices/Female1/Banana.mp3';
import GrapeFemale1SFX from './audio/Voices/Female1/Grape.mp3';
import OrangeFemale1SFX from './audio/Voices/Female1/Orange.mp3';
import WatermelonFemale1SFX from './audio/Voices/Female1/Watermelon.mp3';
import PluralAppleFemale1SFX from './audio/Voices/Female1/Apples.mp3';
import PluralBananaFemale1SFX from './audio/Voices/Female1/Bananas.mp3';
import PluralGrapeFemale1SFX from './audio/Voices/Female1/Grapes.mp3';
import PluralOrangeFemale1SFX from './audio/Voices/Female1/Oranges.mp3';
import PluralWatermelonFemale1SFX from './audio/Voices/Female1/Watermelons.mp3';
import RequestOrderFemale1Sfx from './audio/Voices/Female1/GdayCanIGet.mp3';
import CorrectOrderFemale1Sfx from './audio/Voices/Female1/ThanksMate.mp3';
import WrongOrderFemale1Sfx from './audio/Voices/Female1/ThisAintMyOrder.mp3';
import OneFemale1SFX from './audio/Voices/Female1/One.mp3';
import TwoFemale1SFX from './audio/Voices/Female1/Two.mp3';
import ThreeFemale1SFX from './audio/Voices/Female1/Three.mp3';
import FourFemale1SFX from './audio/Voices/Female1/Four.mp3';
import AndFemale1SfX from './audio/Voices/Female1/And.mp3';
import FiveFemale1SfX from './audio/Voices/Female1/Five.mp3';

// Female 2
import AppleFemale2SFX from './audio/Voices/Female2/Apple.mp3';
import BananaFemale2SFX from './audio/Voices/Female2/Banana.mp3';
import GrapeFemale2SFX from './audio/Voices/Female2/Grape.mp3';
import OrangeFemale2SFX from './audio/Voices/Female2/Orange.mp3';
import WatermelonFemale2SFX from './audio/Voices/Female2/Watermelon.mp3';
import PluralAppleFemale2SFX from './audio/Voices/Female2/Apples.mp3';
import PluralBananaFemale2SFX from './audio/Voices/Female2/Bananas.mp3';
import PluralGrapeFemale2SFX from './audio/Voices/Female2/Grapes.mp3';
import PluralOrangeFemale2SFX from './audio/Voices/Female2/Oranges.mp3';
import PluralWatermelonFemale2SFX from './audio/Voices/Female2/Watermelons.mp3';
import RequestOrderFemale2Sfx from './audio/Voices/Female2/GdayCanIGet.mp3';
import CorrectOrderFemale2Sfx from './audio/Voices/Female2/ThanksMate.mp3';
import WrongOrderFemale2Sfx from './audio/Voices/Female2/ThisAintMyOrder.mp3';
import OneFemale2SFX from './audio/Voices/Female2/One.mp3';
import TwoFemale2SFX from './audio/Voices/Female2/Two.mp3';
import ThreeFemale2SFX from './audio/Voices/Female2/Three.mp3';
import FourFemale2SFX from './audio/Voices/Female2/Four.mp3';
import AndFemale2SfX from './audio/Voices/Female2/And.mp3';
import FiveFemale2SfX from './audio/Voices/Female2/Five.mp3';

const voices = {
    Male1: {
      Apple: AppleMale1SFX,
      Banana: BananaMale1SFX,
      Grape: GrapeMale1SFX,
      Orange: OrangeMale1SFX,
      Watermelon: WatermelonMale1SFX,
      PluralApple: PluralAppleMale1SFX,
      PluralBanana: PluralBananaMale1SFX,
      PluralGrape: PluralGrapeMale1SFX,
      PluralOrange: PluralOrangeMale1SFX,
      PluralWatermelon: PluralWatermelonMale1SFX,
      RequestOrder: RequestOrderMale1Sfx,
      CorrectOrder: CorrectOrderMale1Sfx,
      WrongOrder: WrongOrderMale1Sfx,
      One: OneMale1SFX,
      Two: TwoMale1SFX,
      Three: ThreeMale1SFX,
      Four: FourMale1SFX,
      Five: FiveMale1SfX,
      And: AndMale1SfX,
    },
    Male2: {
      Apple: AppleMale2SFX,
      Banana: BananaMale2SFX,
      Grape: GrapeMale2SFX,
      Orange: OrangeMale2SFX,
      Watermelon: WatermelonMale2SFX,
      PluralApple: PluralAppleMale2SFX,
      PluralBanana: PluralBananaMale2SFX,
      PluralGrape: PluralGrapeMale2SFX,
      PluralOrange: PluralOrangeMale2SFX,
      PluralWatermelon: PluralWatermelonMale2SFX,
      RequestOrder: RequestOrderMale2Sfx,
      CorrectOrder: CorrectOrderMale2Sfx,
      WrongOrder: WrongOrderMale2Sfx,
      One: OneMale2SFX,
      Two: TwoMale2SFX,
      Three: ThreeMale2SFX,
      Four: FourMale2SFX,
      Five: FiveMale2SfX,
      And: AndMale2SfX,
    },
    Female1: {
      Apple: AppleFemale1SFX,
      Banana: BananaFemale1SFX,
      Grape: GrapeFemale1SFX,
      Orange: OrangeFemale1SFX,
      Watermelon: WatermelonFemale1SFX,
      PluralApple: PluralAppleFemale1SFX,
      PluralBanana: PluralBananaFemale1SFX,
      PluralGrape: PluralGrapeFemale1SFX,
      PluralOrange: PluralOrangeFemale1SFX,
      PluralWatermelon: PluralWatermelonFemale1SFX,
      RequestOrder: RequestOrderFemale1Sfx,
      CorrectOrder: CorrectOrderFemale1Sfx,
      WrongOrder: WrongOrderFemale1Sfx,
      One: OneFemale1SFX,
      Two: TwoFemale1SFX,
      Three: ThreeFemale1SFX,
      Four: FourFemale1SFX,
      Five: FiveFemale1SfX,
      And: AndFemale1SfX,
    },
    Female2: {
      Apple: AppleFemale2SFX,
      Banana: BananaFemale2SFX,
      Grape: GrapeFemale2SFX,
      Orange: OrangeFemale2SFX,
      Watermelon: WatermelonFemale2SFX,
      PluralApple: PluralAppleFemale2SFX,
      PluralBanana: PluralBananaFemale2SFX,
      PluralGrape: PluralGrapeFemale2SFX,
      PluralOrange: PluralOrangeFemale2SFX,
      PluralWatermelon: PluralWatermelonFemale2SFX,
      RequestOrder: RequestOrderFemale2Sfx,
      CorrectOrder: CorrectOrderFemale2Sfx,
      WrongOrder: WrongOrderFemale2Sfx,
      One: OneFemale2SFX,
      Two: TwoFemale2SFX,
      Three: ThreeFemale2SFX,
      Four: FourFemale2SFX,
      Five: FiveFemale2SfX,
      And: AndFemale2SfX,
    },
  };
  
  export default voices;